var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C10.796 21 9.77067 20.5863 8.924 19.759C8.07733 18.9317 7.654 17.9223 7.654 16.731V7.654C7.194 7.654 6.80333 7.49667 6.482 7.182C6.16067 6.86667 6 6.479 6 6.019V4.654C6 4.194 6.16067 3.80333 6.482 3.482C6.80333 3.16067 7.194 3 7.654 3H16.327C16.787 3 17.181 3.16067 17.509 3.482C17.8363 3.80267 18 4.19333 18 4.654V6.019C18 6.479 17.8363 6.86667 17.509 7.182C17.181 7.49667 16.787 7.654 16.327 7.654V17.019C16.2497 18.1457 15.794 19.091 14.96 19.855C14.126 20.619 13.1393 21.0007 12 21ZM7.654 6.654H16.327C16.507 6.654 16.664 6.593 16.798 6.471C16.9327 6.349 17 6.19867 17 6.02V4.654C17 4.474 16.9327 4.32 16.798 4.192C16.6633 4.064 16.5063 4 16.327 4H7.654C7.474 4 7.32 4.064 7.192 4.192C7.064 4.32 7 4.474 7 4.654V6.019C7 6.199 7.064 6.34967 7.192 6.471C7.32 6.593 7.474 6.654 7.654 6.654ZM12 20C12.9233 20 13.7087 19.686 14.356 19.058C15.0033 18.43 15.327 17.6543 15.327 16.731V15.981H12.134V14.981H15.327V12.135H12.135V11.135H15.327V7.654H8.654V16.731C8.654 17.6537 8.98067 18.4293 9.634 19.058C10.2893 19.686 11.078 20 12 20Z",
    fill: "#50869A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabsIcon);
export default __webpack_public_path__ + "static/media/LabsIcon.0e3e50bf943e875a56d6531564027e78.svg";
export { ForwardRef as ReactComponent };